export const USER_TEST_ADMIN = 'admin0001@mail.ru';
